import React from "react";

function ViewWaad({ data }) {
    if (!data) {
        return <div className="text-center py-4">No data available</div>;
    }

    const isActive = (status) => {
        return status === "active" || status === "Active" || status === 1 || status === true;
    };

    return (
        <div className="custom-modal-body">
            <div className="model-custum">
                <h3>{data?.waad_name || "Waad Details"}</h3>

                <div className="view-details-grid">
                    {/* WAAD NAME */}
                    <div className="view-detail-card">
                        <span>Waad Name</span>
                        <h5>{data?.waad_name || "N/A"}</h5>
                    </div>

                    {/* WAAD CODE */}
                    <div className="view-detail-card">
                        <span>Waad Code</span>
                        <h5>{data?.waad_code || "N/A"}</h5>
                    </div>

                    {/* DESCRIPTION */}
                    <div className="view-detail-card">
                        <span>Description</span>
                        <h5>{data?.description || "N/A"}</h5>
                    </div>

                    {/* STATUS */}
                    <div className="view-detail-card">
                        <span>Status</span>
                        <h5>
                            <span className={`badge ${isActive(data?.status) ? 'bg-success' : 'bg-danger'}`}>
                                {isActive(data?.status) ? "Active" : "Inactive"}
                            </span>
                        </h5>
                    </div>

                    {/* TOTAL GAONS */}
                    <div className="view-detail-card">
                        <span>Total Gaons</span>
                        <h5>
                            <span className="badge bg-info">
                                {data?.gaon_count || 0}
                            </span>
                        </h5>
                    </div>

                    {/* CREATED AT */}
                    <div className="view-detail-card">
                        <span>Created At</span>
                        <h5>
                            {data?.created_at
                                ? new Date(data.created_at).toLocaleDateString()
                                : "N/A"}
                        </h5>
                    </div>

                    {/* UPDATED AT */}
                    <div className="view-detail-card">
                        <span>Updated At</span>
                        <h5>
                            {data?.updated_at
                                ? new Date(data.updated_at).toLocaleDateString()
                                : "N/A"}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewWaad;